module.exports = __webpack_public_path__ + "static/img/4.3ffbe60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/4.png
// module id = qw0e
// module chunks = 1